import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  setSecContent,
  setShowHeaderFlag,
} from "../reducers/slices/SetSecDataSlice";
import Routers, { pagePath } from "../app/Routers";
import { fetchSecPortalApi } from "../api/Api";
import Loader from "../components/Loader";
import Header from "./Header";
import Footer from "./Footer";
import store from "../store/store";
import AchHeader from "../pages/achEnrollment/ACHHeader";
import DefaultHeader from "../pages/default-overview/DefaultHeader";
import { getRedirectPath } from "src/utils/UtilityFunction";
import {SUCCESS_STR} from "src/utils/Constants";
import useRefreshOnBack from "src/hooks/UseRefreshOnBack";
import {initializeRequestId} from "src/utils/TokenUtils";

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [showDefaultPageFlag, setShowDefaultPageFlag] = useState(false);

  useEffect(() => {
    // Disable right-click globally
    const disableRightClick = (event: MouseEvent) => {
      event.preventDefault();
    };

    const handleF12Press = (event: KeyboardEvent) => {
      // prettier-ignore
      if (event.key === 'F12' || event.code === 'F12') {
        event.preventDefault();
      }
    };

    document.addEventListener("contextmenu", disableRightClick);
    document.addEventListener("keydown", handleF12Press);

    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
      document.removeEventListener("keydown", handleF12Press);
    };
  }, []);

  const getEncryptedEmail = () => {
    let encryptEmail = new URLSearchParams(window.location.search).get("id");
    if (encryptEmail) {
      encryptEmail = encodeURIComponent(encryptEmail);
      localStorage.setItem("id", encryptEmail);
      localStorage.setItem(
        "source",
        new URLSearchParams(window.location.search).get("source") || ""
      );
    } else {
      encryptEmail = localStorage.getItem("id");
    }
    return encryptEmail;
  };

  const setPageTitle = (result: any) => {
    const pageTitle = result?.content?.overview?.conteDataDetails[0]
      ?.contentData
      ? result.content.overview.conteDataDetails[0].contentData
      : "Virtual Card Benefits";
    document.title = pageTitle + " – J.P.Morgan";
  };

  const showHeader = useSelector(
    (state: ReturnType<typeof store.getState>) =>
      state.getSecData.showHeaderFlag
  );

  const headerComponent = () => {
    if (showHeader) { // Use boolean directly
      return showDefaultPageFlag ? <Header /> : <DefaultHeader />;
    }
    return <AchHeader />;
  };

  const handleValidUser = (result: any) => {
    dispatch(setSecContent(result));
    const pathName = window.location.pathname;
    if (result?.content?.contentTargetEnrollment === "ACH") {
      dispatch(setShowHeaderFlag(false)); // Pass boolean
    }

    const redirectPath = getRedirectPath(pathName, pagePath);
    setShowDefaultPageFlag(true);

    navigate(redirectPath);
  };

  const handleInvalidUser = () => {
    setShowDefaultPageFlag(false);
    setLoading(false);
    const source = localStorage.getItem("source");
    if (source === "ACH" || source === "ACHVC") {
      navigate("/errorPage");
      dispatch(setShowHeaderFlag(false)); // Pass boolean
    } else {
      navigate("/defaultOverview");
    }
  };

  const getSecData = async () => {
    // Skip API call if the user is on the session timeout page
    if (location.pathname === pagePath.sessionPage) {
      dispatch(setShowHeaderFlag(false));
      return;
    }

    const encryptEmail = getEncryptedEmail();
    try {
      setLoading(true);
      const response = await fetchSecPortalApi(
        encryptEmail,
        localStorage.getItem("source")
      );
      const result = response.data;
      if (result.status === SUCCESS_STR) {
        setPageTitle(result);
        handleValidUser(result);
      }else {
        handleInvalidUser();
      }
    } catch (err) {
      handleInvalidUser();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSecData();
    initializeRequestId();
  }, []);

  useRefreshOnBack();

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div>
          {headerComponent()}
          <main
            id="mainContent"
            autoFocus
            tabIndex={-1}
            className="flex flex-col min-h-[800px]"
          >
            <Routers />
          </main>
          <div className="mt-[150px]">
            <Footer />
          </div>
        </div>
      )}
    </>
  );
}

export default App;